<template>
  <div>
    <label
      v-if="label"
      class="field-label"
    >
      {{ label }}
    </label>

    <v-select
      v-model="model"
      :disabled="disabled"
      :error-messages="errorMessages"
      :items="formattedAvailableDates"
      :placeholder="placeholder"
      :rules="rules"
      :style="`width: ${width}px;`"
      :height="height"
      class="custom-select"
      dense
      hide-details="auto"
      item-text="displayText"
      item-value="value"
      outlined
      @change="onDateChange"
    >
      <template #item="{item}">
        <v-list-item-content>
          <v-list-item-title v-text="item.displayText" />
        </v-list-item-content>
      </template>

      <template #selection="{item}">
        <div>{{ item ? item.displayText : '' }}</div>
      </template>
    </v-select>
  </div>
</template>

  <script>
export default {
  name      : 'SelectAvailableDate',
  components: {},
  directives: {},
  mixins    : [],
  props     : {
    value: {
      type   : String,
      default: ''
    },

    selectedDate: {
      type   : String,
      default: ''
    },

    availableDates: {
      type   : Array,
      default: () => []
    },

    label: {
      type   : String,
      default: 'Portfolio as of'
    },

    placeholder: {
      type   : String,
      default: 'Select a date'
    },

    disabled: {
      type   : Boolean,
      default: false
    },

    rules: {
      type   : Array,
      default: () => []
    },

    errorMessages: {
      type   : Array,
      default: () => []
    },

    width: {
      type   : [String, Number],
      default: 222
    },

    height: {
      type   : [String, Number],
      default: 42
    },

    dateFormat: {
      type   : String,
      default: 'MMM DD YYYY'
    }
  },
  dataStore: {},
  enums    : {},
  dataModel: null,
  data () {
    return {}
  },
  computed: {
    formattedAvailableDates () {
      return this.availableDates.map(date => ({
        value      : date,
        displayText: this.formatDate(date)
      }))
    },

    model: {
      get () {
        return this.value || this.selectedDate
      },
      set (val) {
        this.$emit('input', val)
      }
    }
  },
  watch: {
    selectedDate: {
      handler (newVal) {
        if (newVal && !this.value) {
          this.model = newVal
        }
      },
      immediate: true
    },

    availableDates: {
      handler (newVal) {
        // If we have available dates but no selected date, use the first one
        if (newVal.length > 0 && !this.model) {
          this.model = newVal[0]
        }
      },
      immediate: true
    }
  },
  beforeCreate () {},
  created () {},
  beforeMount () {},
  mounted () {},
  beforeUpdate () {},
  updated () {},
  beforeDestroy () {},
  destroyed () {},
  methods: {
    formatDate (dateString) {
      if (!dateString) return ''
      return this.$dayjs(dateString).format(this.dateFormat)
    },

    onDateChange (selectedDate) {
      this.$emit('change', selectedDate)
    }
  }
}
  </script>

  <style scoped>
  .field-label {
    display: block;
    margin-bottom: 8px;
    font-size: 14px;
    font-weight: 500;
    color: var(--v-synthesis-brand-dark-blue-base);
  }

  /deep/ .v-select .v-input__slot {
    min-height: 42px;
  }

  /deep/ .v-select .v-select__selections {
    text-align: center;
  }

  /deep/ .custom-select .v-input__slot {
    background-color: white !important;
    border: 1px solid #6E8EDF !important;
  }

  /deep/ .custom-select .v-input__slot:focus-within {
    border-color: #6E8EDF !important;
    box-shadow: 0 0 0 2px rgba(110, 142, 223, 0.2) !important;
  }
  </style>
